import { FC, ReactNode } from 'react'
import Button from 'components/Button'
import Typography from 'components/Typography'
import IconChevronLeft from 'icons/IconChevronLeft'
import styles from 'pages/perfil/minhas-indicacoes/MinhasIndicacoes.module.scss'

export type TProps = {
  title: string
  showBackButton?: boolean
  trailingContent?: ReactNode
  onBackButtonClick?: () => void
}

const Header: FC<TProps> = ({
  title,
  showBackButton = false,
  trailingContent,
  onBackButtonClick,
}) => {
  return (
    <div className={styles.ecIndicationsPageHeader}>
      <div className={styles.ecIndicationsPageHeaderLeading}>
        {showBackButton && (
          <Button
            size="small"
            element="a"
            href="/perfil/minhas-indicacoes"
            shape="circle"
            aria-label="Voltar para as minhas indicações"
            Icon={{
              Component: IconChevronLeft,
              title: 'Ícone: Voltar',
              color: 'grey900',
            }}
            onClick={onBackButtonClick}
          />
        )}
        <Typography bold variant="Title">
          {title}
        </Typography>
      </div>
      <div className={styles.ecIndicationsPageHeaderTrailing}>
        {trailingContent}
      </div>
    </div>
  )
}

export default Header
